import { TrackLib } from '@poseidon/tracklib';
import { trackingConfig } from './tracking-config';
import * as Logger from '@navigator/frontend-logger';

export function getTrackLib(): TrackLib {
  const TrackLibConstructor = (window as any).TrackLib;
  let tracklib: TrackLib;
  try {
    tracklib = new TrackLibConstructor(trackingConfig);
  } catch (error) {
    Logger.error('tracker: Could not create a TrackLib instance:', error);
    tracklib = {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      track: /* istanbul ignore next function */ () => {}
    } as unknown as TrackLib
  }
  return tracklib;
}

